var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBenefit1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 78.5,
    height: 63.415,
    viewBox: "0 0 78.5 63.415",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_04",
    transform: "translate(-19.195 -28.554)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27277",
    "data-name": "Path 27277",
    d: "M146.583,28.554H99.633a1.726,1.726,0,0,0-1.718,1.73V48.933h2.076v-18.3h46.235V89.893H99.991V84.208H97.915v6.031a1.726,1.726,0,0,0,1.718,1.73h46.95a1.726,1.726,0,0,0,1.718-1.73V30.283A1.726,1.726,0,0,0,146.583,28.554Z",
    transform: "translate(-50.606)",
    fill: "#002b3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27278",
    "data-name": "Path 27278",
    d: "M152.568,101.327H120.746a1.038,1.038,0,1,1,0-2.075h31.823a1.038,1.038,0,0,1,0,2.075Z",
    transform: "translate(-64.616 -45.449)",
    fill: "#022b3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27279",
    "data-name": "Path 27279",
    d: "M142.363,182.2H120.745a1.038,1.038,0,1,1,0-2.075h21.618a1.038,1.038,0,1,1,0,2.075Z",
    transform: "translate(-64.616 -97.44)",
    fill: "#022b3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27280",
    "data-name": "Path 27280",
    d: "M135.619,166.219H120.746a1.038,1.038,0,1,1,0-2.075h14.873a1.038,1.038,0,1,1,0,2.075Z",
    transform: "translate(-64.616 -87.166)",
    fill: "#022b3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27281",
    "data-name": "Path 27281",
    d: "M187.124,166.219H172.077a1.038,1.038,0,0,1,0-2.075h15.047a1.038,1.038,0,0,1,0,2.075Z",
    transform: "translate(-97.616 -87.166)",
    fill: "#022b3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27282",
    "data-name": "Path 27282",
    d: "M132.074,58.809v4.536H124.2V55.322h4.469V53.247h-4.636a1.919,1.919,0,0,0-1.909,1.925v8.322a1.919,1.919,0,0,0,1.909,1.925h8.2a1.919,1.919,0,0,0,1.909-1.925V58.809Z",
    transform: "translate(-66.173 -15.874)",
    fill: "#3cc7c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27283",
    "data-name": "Path 27283",
    d: "M135.008,58.711a1.34,1.34,0,0,1-.949-2.286l6.2-6.228a1.371,1.371,0,0,1,1.895,0,1.342,1.342,0,0,1,.007,1.894l-6.2,6.23A1.331,1.331,0,0,1,135.008,58.711Z",
    transform: "translate(-73.591 -13.667)",
    fill: "#3cc7c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27284",
    "data-name": "Path 27284",
    d: "M193.091,123.98v4.536h-7.869v-8.022h4.47v-2.076h-4.636a1.92,1.92,0,0,0-1.909,1.926v8.322a1.919,1.919,0,0,0,1.909,1.925h8.2a1.92,1.92,0,0,0,1.909-1.925V123.98h-2.076Z",
    transform: "translate(-105.399 -57.77)",
    fill: "#3cc7c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27285",
    "data-name": "Path 27285",
    d: "M196.027,123.883a1.34,1.34,0,0,1-.95-2.285l6.2-6.229a1.371,1.371,0,0,1,1.9-.005,1.34,1.34,0,0,1,.005,1.895l-6.2,6.229A1.346,1.346,0,0,1,196.027,123.883Z",
    transform: "translate(-112.818 -55.565)",
    fill: "#3cc7c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27286",
    "data-name": "Path 27286",
    d: "M192.288,65.42h-8.2a1.92,1.92,0,0,1-1.91-1.925V55.172a1.92,1.92,0,0,1,1.91-1.925h8.2a1.92,1.92,0,0,1,1.909,1.925v8.322A1.92,1.92,0,0,1,192.288,65.42Zm-8.036-2.075h7.869V55.322h-7.869Z",
    transform: "translate(-104.775 -15.874)",
    fill: "#022b3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27287",
    "data-name": "Path 27287",
    d: "M132.24,130.311h-8.2a1.919,1.919,0,0,1-1.909-1.925v-8.322a1.919,1.919,0,0,1,1.909-1.925h8.2a1.919,1.919,0,0,1,1.909,1.925v8.322A1.919,1.919,0,0,1,132.24,130.311Zm-8.035-2.075h7.869v-8.022H124.2Z",
    transform: "translate(-66.173 -57.59)",
    fill: "#022b3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27288",
    "data-name": "Path 27288",
    d: "M96.661,144.965a1.037,1.037,0,0,1-.65-1.846,3.005,3.005,0,0,0,.981-1.277,2.543,2.543,0,0,0-.106-1.889.551.551,0,0,0-.408-.268,3.4,3.4,0,0,0-2.012.9,1.067,1.067,0,0,1-1.464-.1,1.037,1.037,0,0,1,.1-1.464c.181-.157,1.959-1.635,3.672-1.386a2.672,2.672,0,0,1,1.9,1.275,4.557,4.557,0,0,1,.264,3.651,5.033,5.033,0,0,1-1.629,2.18,1.035,1.035,0,0,1-.446.209Z",
    transform: "translate(-47.283 -70.103)",
    fill: "#47c2c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27289",
    "data-name": "Path 27289",
    d: "M38.985,131.367a8.633,8.633,0,0,1-4.369-1.284l-.106-.076c-1.586-1.386-6.752-5.98-7.383-7.488a65.424,65.424,0,0,1-4.041-9.548c-.351-1-1.329-3.132-2.48-3.884a3.626,3.626,0,0,1-1.41-2.7,2.872,2.872,0,0,1,1.379-2.255,1.032,1.032,0,0,1,.394-.17,7.19,7.19,0,0,1,1.233-.091c2.087,0,7.109.7,10.14,7L46.636,96.848h0a5.091,5.091,0,0,1,3.4-1.532,4.122,4.122,0,0,1,2.394.8,1.033,1.033,0,0,1,.217.205,3.4,3.4,0,0,1-.81,4.828l-5.28,5.29a3.18,3.18,0,0,1,2.663,3.883,5.185,5.185,0,0,1-2.634,3.21,1.06,1.06,0,0,1-1.415-.324,1.023,1.023,0,0,1,.329-1.421,3.354,3.354,0,0,0,1.7-1.875,1.312,1.312,0,0,0-.135-.94,1.272,1.272,0,0,0-.869-.513,4.17,4.17,0,0,0-2.511.844,1.058,1.058,0,0,1-1.391-.14,1.023,1.023,0,0,1,.039-1.4l8.09-8.1c1.058-.871.868-1.607.667-1.964a2.027,2.027,0,0,0-1.078-.324,2.9,2.9,0,0,0-1.877.9L32.714,113.388a1.045,1.045,0,0,1-.938.274,1.027,1.027,0,0,1-.751-.639c-2.457-6.409-6.971-7.1-8.8-7.1-.273,0-.491.015-.639.03a.815.815,0,0,0-.327.516,1.605,1.605,0,0,0,.554.956c1.97,1.322,3.109,4.541,3.232,4.906a63.653,63.653,0,0,0,3.935,9.286.944.944,0,0,1,.077.184c.263.588,3.333,3.6,6.714,6.587a6.516,6.516,0,0,0,3.231.955,4.422,4.422,0,0,0,2.775-.911l9.241-9.068c1.008-1.19,1.224-1.982,1.075-2.312a1.9,1.9,0,0,0-1.341-.674l-.945-.177.468-.84a1.03,1.03,0,0,0,.079-.187,1.266,1.266,0,0,0,.046-.209l.1-.731.724.145a3.572,3.572,0,0,1,2.754,1.835c.557,1.235.071,2.764-1.446,4.544l-9.345,9.174A6.638,6.638,0,0,1,38.985,131.367Z",
    transform: "translate(0 -42.92)",
    fill: "#47c2c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27290",
    "data-name": "Path 27290",
    d: "M40.794,96.75a.6.6,0,0,1-.473-.234l-3.448-4.423a.664.664,0,0,1,.06-.878.609.609,0,0,1,.886.066L41.268,95.7a.664.664,0,0,1-.06.878A.6.6,0,0,1,40.794,96.75Z",
    transform: "translate(-11.276 -40.179)",
    fill: "#3cc7c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27291",
    "data-name": "Path 27291",
    d: "M69.144,96.9a.588.588,0,0,1-.431-.189.658.658,0,0,1-.019-.873l3.739-4.348a.6.6,0,0,1,.883-.021.658.658,0,0,1,.018.872L69.6,96.691A.6.6,0,0,1,69.144,96.9Z",
    transform: "translate(-31.721 -40.33)",
    fill: "#3cc7c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27292",
    "data-name": "Path 27292",
    d: "M58.252,93.734a.665.665,0,0,1-.692-.632V86.994a.695.695,0,0,1,1.384,0V93.1A.665.665,0,0,1,58.252,93.734Zm0-6.684v5.992a.054.054,0,0,0,.025-.005l-.025-5.987Z",
    transform: "translate(-24.663 -37.163)",
    fill: "#3cc7c9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenefit1);
export default __webpack_public_path__ + "static/media/Benefit-1.af6a10211e3a50b5f5cd0cf2903a0731.svg";
export { ForwardRef as ReactComponent };